export const findErrorsInMessages = ({ messages, bagErrorCodes }) =>
  messages.find(({ errorCode } = {}) => bagErrorCodes.includes(errorCode)) ||
  null;
